import { useCallback, useRef } from 'react';

export function useTimeout(): [
  (callback: () => void, ms?: number) => () => void,
  () => void
] {
  const timeoutRef = useRef<number>();

  const clearDebouncedTimeout = useCallback(() => {
    const dTimeout = timeoutRef.current;
    dTimeout && clearTimeout(dTimeout);
  }, []);

  const debouncedCall = useCallback(
    (callback: () => void, ms?: number) => {
      // remove existing timeout
      clearDebouncedTimeout();
      // set new timeout
      timeoutRef.current = setTimeout(callback, ms);
      return clearDebouncedTimeout;
    },
    [clearDebouncedTimeout]
  );

  return [debouncedCall, clearDebouncedTimeout];
}
